var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { MenuItem, Typography } from "@mui/material";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { MuiStack } from "../../../components";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { JCNoByOrganizationAPICall, LabourListAPICall } from "../services/apiCall";
var WPIWorkOrderDetails = function (props) {
    var _getLocalStorageItem, _getLocalStorageItem2, _value$WPODetails;
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'WPODetails' : _a;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var JCNoBySuppliernAPICall = function (params) { return JCNoByOrganizationAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread({
            OrganizationId: UserOrganization,
            ParentOrganization: UserParentOrganization
        }, params.request)
    })); };
    var LabourListBysupplier = function (params) { return LabourListAPICall(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread({
            SupplierId: value === null || value === void 0 ? void 0 : value.SupplierId
        }, params.request)
    })); };
    var columns = [{
            type: 'searchSelect',
            field: 'JobCard',
            headerName: 'Job card',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            minWidth: 250,
            placeholder: 'Search job card',
            getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.JobCardNo; },
            getListData: JCNoBySuppliernAPICall,
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                JobCard: value,
                JobCardNo: value === null || value === void 0 ? void 0 : value.JobCardNo,
                JobCardId: value === null || value === void 0 ? void 0 : value.JobCardId
            }); },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.JobCardNo; },
            renderCell: function (params) {
                var _params$row, _params$row2;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#1B1D21'
                    }
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.JobCardNo ? "".concat(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.JobCardNo) : ""));
            }
        }, {
            type: 'searchSelect',
            field: 'Service',
            headerName: 'Service name',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            minWidth: 250,
            placeholder: 'Select service name',
            getListData: LabourListBysupplier,
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.ServiceName; },
            getOptionLabel: function (option) { return option.Name + " | " + (option === null || option === void 0 ? void 0 : option.Code); },
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                Service: value,
                ServiceCode: value === null || value === void 0 ? void 0 : value.Code,
                ServiceName: value === null || value === void 0 ? void 0 : value.Name,
                ChildId: value === null || value === void 0 ? void 0 : value.id
            }); },
            renderCell: function (params) {
                var _params$row3, _params$row4, _params$row5, _params$row6;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#1B1D21'
                    }
                }, params !== null && params !== void 0 && (_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.ServiceName ? "".concat(params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ServiceName) : ""), /*#__PURE__*/ React.createElement(Typography, {
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#6A7682'
                    }
                }, params !== null && params !== void 0 && (_params$row5 = params.row) !== null && _params$row5 !== void 0 && _params$row5.ServiceCode ? "#".concat(params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.ServiceCode) : ""));
            },
            renderOption: function (props, option) {
                return /*#__PURE__*/ React.createElement(MenuItem, props, /*#__PURE__*/ React.createElement(MuiStack, {
                    width: '200px'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    sx: {
                        overflow: "hidden",
                        whiteSpace: 'wrap',
                        textOverflow: 'ellipsis'
                    }
                }, option === null || option === void 0 ? void 0 : option.Name)), /*#__PURE__*/ React.createElement(MuiStack, {
                    width: '100px',
                    borderLeft: "1px solid ".concat(systemColor.grey),
                    paddingX: 2
                }, /*#__PURE__*/ React.createElement(Typography, null, option === null || option === void 0 ? void 0 : option.Code)));
            }
        }, {
            field: 'UnitOfMeasurementName',
            headerName: 'UOM',
            flex: 1,
            headerAlign: 'left',
            editable: false,
            align: 'left',
            placeholder: "Select UOM",
            minWidth: 150
        }, {
            type: 'number',
            field: 'OdometerReading',
            headerName: 'Odometer reading',
            editable: false,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            minWidth: 150
        }, {
            type: 'number',
            field: 'Rate',
            headerName: 'Rate (₹)',
            editable: false,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            minWidth: 150
        }, {
            field: 'RequestedQuantity',
            headerName: 'Quantity',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            minWidth: 150
        }, {
            type: 'number',
            field: 'Taxes',
            headerName: 'Taxes (%)',
            editable: false,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            minWidth: 150
        }, {
            type: 'number',
            field: 'TaxAmount',
            headerName: 'Tax amt.(₹)',
            editable: false,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            minWidth: 150
        }, {
            field: 'Discount',
            headerName: 'Discount (%)',
            editable: false,
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            minWidth: 150
        }, {
            type: 'number',
            field: 'DiscountRate',
            headerName: 'Discount (₹)',
            editable: false,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            placeholder: '00.00',
            minWidth: 150
        }, {
            type: 'number',
            field: 'TotalAmount',
            headerName: 'Total amount (₹)',
            editable: false,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            placeholder: '00.00',
            minWidth: 150
        }, {
            field: 'Remarks',
            headerName: 'Remarks',
            editable: true,
            flex: 1,
            placeholder: "Enter remarks",
            headerAlign: 'left',
            align: 'left',
            minWidth: 250
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        onChange: onChange,
        disableDeleteRow: true,
        dataGridHeader: "Work order details",
        dataGridProps: {
            rowSelection: false,
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                pinnedColumns: {
                    left: ['__check__', 'JobCard'],
                    right: ['Remarks']
                }
            },
            processRowUpdate: function (newRow, oldRow) { return __awaiter(void 0, void 0, void 0, function () {
                var _newRow$Service, _oldRow$Service, _newRow$JobCard, _oldRow$JobCard, row, _newRow$Service2, _newRow$Service3, _newRow$Service4, _newRow$Service5, _newRow$Service6, _newRow$Service7, _newRow$Service8, _newRow$Service9, _newRow$Service10, _newRow$Service11, _newRow$Service12, _newRow$JobCard2, _newRow$JobCard3, _newRow$JobCard4, _newRow$JobCard5;
                return __generator(this, function (_a) {
                    row = newRow;
                    if ((newRow === null || newRow === void 0 || (_newRow$Service = newRow.Service) === null || _newRow$Service === void 0 ? void 0 : _newRow$Service.id) !== (oldRow === null || oldRow === void 0 || (_oldRow$Service = oldRow.Service) === null || _oldRow$Service === void 0 ? void 0 : _oldRow$Service.id) || (newRow === null || newRow === void 0 || (_newRow$JobCard = newRow.JobCard) === null || _newRow$JobCard === void 0 ? void 0 : _newRow$JobCard.id) !== (oldRow === null || oldRow === void 0 || (_oldRow$JobCard = oldRow.JobCard) === null || _oldRow$JobCard === void 0 ? void 0 : _oldRow$JobCard.id)) {
                        row = _objectSpread(_objectSpread({}, newRow), {}, {
                            UnitOfMeasurementId: newRow === null || newRow === void 0 || (_newRow$Service2 = newRow.Service) === null || _newRow$Service2 === void 0 ? void 0 : _newRow$Service2.UnitOfMeasurementId,
                            UnitOfMeasurementName: newRow === null || newRow === void 0 || (_newRow$Service3 = newRow.Service) === null || _newRow$Service3 === void 0 ? void 0 : _newRow$Service3.UOMName,
                            HsnId: newRow === null || newRow === void 0 || (_newRow$Service4 = newRow.Service) === null || _newRow$Service4 === void 0 ? void 0 : _newRow$Service4.HsnCodeId,
                            HsnCode: newRow === null || newRow === void 0 || (_newRow$Service5 = newRow.Service) === null || _newRow$Service5 === void 0 ? void 0 : _newRow$Service5.HsnCode,
                            SacId: newRow === null || newRow === void 0 || (_newRow$Service6 = newRow.Service) === null || _newRow$Service6 === void 0 ? void 0 : _newRow$Service6.SacCodeId,
                            SacCode: newRow === null || newRow === void 0 || (_newRow$Service7 = newRow.Service) === null || _newRow$Service7 === void 0 ? void 0 : _newRow$Service7.SacCode,
                            TaxId: newRow === null || newRow === void 0 || (_newRow$Service8 = newRow.Service) === null || _newRow$Service8 === void 0 ? void 0 : _newRow$Service8.TaxId,
                            TaxName: newRow === null || newRow === void 0 || (_newRow$Service9 = newRow.Service) === null || _newRow$Service9 === void 0 ? void 0 : _newRow$Service9.TaxValue,
                            ChargeId: newRow === null || newRow === void 0 || (_newRow$Service10 = newRow.Service) === null || _newRow$Service10 === void 0 ? void 0 : _newRow$Service10.ChargeId,
                            DiscountId: newRow === null || newRow === void 0 || (_newRow$Service11 = newRow.Service) === null || _newRow$Service11 === void 0 ? void 0 : _newRow$Service11.DiscountId,
                            Rate: newRow === null || newRow === void 0 || (_newRow$Service12 = newRow.Service) === null || _newRow$Service12 === void 0 || (_newRow$Service12 = _newRow$Service12.PurchaseBasePrice) === null || _newRow$Service12 === void 0 ? void 0 : _newRow$Service12.Price,
                            TechnicianName: newRow === null || newRow === void 0 || (_newRow$JobCard2 = newRow.JobCard) === null || _newRow$JobCard2 === void 0 ? void 0 : _newRow$JobCard2.TechnicianName,
                            TechnicianId: newRow === null || newRow === void 0 || (_newRow$JobCard3 = newRow.JobCard) === null || _newRow$JobCard3 === void 0 ? void 0 : _newRow$JobCard3.TechnicianId,
                            OdometerReading: newRow === null || newRow === void 0 || (_newRow$JobCard4 = newRow.JobCard) === null || _newRow$JobCard4 === void 0 ? void 0 : _newRow$JobCard4.ODOMeterReading,
                            VIN: newRow === null || newRow === void 0 || (_newRow$JobCard5 = newRow.JobCard) === null || _newRow$JobCard5 === void 0 ? void 0 : _newRow$JobCard5.VinNo
                        });
                    }
                    return [2 /*return*/, row];
                });
            }); }
        },
        rows: (_value$WPODetails = value.WPODetails) !== null && _value$WPODetails !== void 0 ? _value$WPODetails : [{
                id: 1
            }],
        validationModel: {
            Quantity: function (value, row) {
                if (value < 1)
                    return "Quantity must not go below 0.";
            }
        },
        error: error === null || error === void 0 ? void 0 : error['WPODetails']
    }));
};
export default WPIWorkOrderDetails;
